import React from 'react';
import { Box, Typography } from '@mui/material';
import { PRESERVE_LINE_BREAKS_SX } from '../Events/ManageEvent/eventFormConstants';

const SettingsLegalDocument = ({ title, sections }) => (
  <Box>
    {title ? (
      <Typography
        sx={{
          fontSize: '1.1875rem',
          fontWeight: 800,
          color: 'text.primary',
          mb: 2.75,
        }}
      >
        {title}
      </Typography>
    ) : null}
    <Box>
      {sections.map((section) => {
        const paragraphs = Array.isArray(section.body) ? section.body : [section.body];

        return (
          <Box key={section.title} sx={{ mb: 2.5 }}>
            <Typography
              sx={{
                fontSize: '0.90625rem',
                fontWeight: 700,
                color: 'text.primary',
                mb: 0.75,
              }}
            >
              {section.title}
            </Typography>
            {paragraphs.map((paragraph) => (
              <Typography
                key={paragraph}
                component="p"
                sx={{
                  m: 0,
                  mb: 0.75,
                  fontSize: '0.84375rem',
                  color: '#6B6560',
                  lineHeight: 1.6,
                  '&:last-of-type': { mb: 0 },
                  ...PRESERVE_LINE_BREAKS_SX,
                }}
              >
                {paragraph}
              </Typography>
            ))}
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default SettingsLegalDocument;
